// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"28":"bb259500","453":"639c9932"}[chunkId] + ".chunk.js";
};